import { render, staticRenderFns } from "./KnowledgeLevel.vue?vue&type=template&id=4bc886ca&scoped=true&"
import script from "./KnowledgeLevel.vue?vue&type=script&lang=js&"
export * from "./KnowledgeLevel.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeLevel.vue?vue&type=style&index=0&id=4bc886ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc886ca",
  null
  
)

export default component.exports